import { isDefined } from '../utils/is-defined';
import { WidgetType } from '../types/widget-type';
import { IWidgetSettingsModel } from './widget-settings.model';
import { IMediaBankFileReference } from '../media-bank';
import { Subject } from 'rxjs';

export class WidgetPlaceHolderControlModel {
    Id: number;
    PlaceHolderId: number;
    WidgetId: number;
    WidgetType;
    Settings: IWidgetSettingsModel;
    SortOrder: number;
    TagIds: number[];
    MediaBankFileReferences: IMediaBankFileReference[];
    ccmInternalId: string;
    isEmpty: boolean = false;
    objectId: any;
    objectType: any;
    private static internalIdKey = 0;
    Names: any;
    Name: string;

    constructor(data?) {
        if (!isDefined(data)) {
            data = {};
        }

        this.Id = data.Id;
        this.PlaceHolderId = data.PlaceHolderId;
        this.WidgetId = data.WidgetId;
        this.WidgetType = data.WidgetType;

        this.Settings =
            typeof data.Settings == 'string' && data.Settings.length > 0
                ? JSON.parse(data.Settings)
                : data.Settings || {};
        /*
        // default settings
        if (!isDefined(this.Settings.DisplayContainer))
        {
            this.Settings.DisplayContainer = true;
        }

        if (!isDefined(this.Settings.DisplayHeader))
        {
            this.Settings.DisplayHeader = true;
        }
*/

        if (!isDefined(this.Settings.HeaderNames)) {
            this.Settings.HeaderNames = {};
        }

        if (!isDefined(this.Settings.ShowInApp) && isShowInAppAvailable(this.WidgetId)) {
            this.Settings.ShowInApp = true;
        }

        this.SortOrder = data.SortOrder;
        this.TagIds = data.TagIds || [];
        this.MediaBankFileReferences = data.MediaBankFileReferences || [];

        this.ccmInternalId = data.ccmInternalId;
        if (!this.ccmInternalId) {
            this.ccmInternalId = 'WidgetPlaceHolderControl:' + WidgetPlaceHolderControlModel.internalIdKey++;
        }
    }
}

const mobileWidgets = [
    WidgetType.DocumentListing,
    WidgetType.SiteMap,
    WidgetType.ForumListing,
    WidgetType.AdvancedText,
];

function isShowInAppAvailable(widgetId) {
    return mobileWidgets.indexOf(widgetId) > -1;
}
